let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("p2kB9")).then(() => parcelRequire('3ttPY'));